import { Modal as ModalAD, ModalProps } from "antd";
import React from "react";
import styled from "styled-components";

type ExtraProps = { resetLineHeight?: boolean; padding?: number | string };

const StyledModal = styled(ModalAD)<ExtraProps>`
  .ant-modal-content,
  .ant-modal-header {
    border-radius: 8px;
  }

  .ant-modal-body {
    ${({ resetLineHeight }) => (resetLineHeight ? "line-height: 1.3;" : "")};

    ${({ padding }) => (padding ? `padding: ${padding};` : "")};
  }
`;

type Props = ModalProps & ExtraProps;

export const Modal: React.FC<Props> = props => {
  return <StyledModal footer={null} {...props} width={props.width ?? 400} resetLineHeight />;
};
